import { Box, Link, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { CustomButton, TextField } from '../../../../v2/MUI_custom_component';
import GlassModal from '../../../../v2/MUI_custom_component/Modal/GlassModal';
import tncData from './../Components/tnc.json';
import { sendOTPAction } from '../API/Action';
import { useNavigate } from 'react-router-dom';
import { OTP_PURPOSE_ENUM } from '../../Enum';
import { toast } from 'react-toastify';
import { encryptPassword } from '../../../../v2/Utils/Encryption/NodeForgeEncryption';
import { useDispatch } from 'react-redux';
import { validateMobile } from '../../../Common/Validation/mobileValidation';
import { MOBILE_REGEX } from './regex';

function RegisterForm({ }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [apiError, setApiError] = useState('');
    const [mobile, setMobile] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);
    const [tncOpen, setTncOpen] = useState(false);
    const handleTncClick = () => setTncOpen(true);
    const handleTncClose = () => setTncOpen(false);
    const isMobileValid = MOBILE_REGEX.test(mobile);

    const handleSendOtp = async () => {
        const mobileValidation = validateMobile(mobile);
        if (!mobileValidation.valid) {
            setErr(mobileValidation.message);
            return;
        }
        setLoading(true);
        const encryptedMobile = encryptPassword(mobile);
        const payload = { 
            mobile_number: encryptedMobile,
            purpose: OTP_PURPOSE_ENUM.REGISTER
        };
        const { error, message } = await sendOTPAction(payload);
        setLoading(false);
        if (!error) {
            dispatch({ type: 'SET_MOBILE', payload: encryptedMobile });
            navigate('/otp', {state: { mobile_no: mobile }});
        } else {
            // setApiError(message);
            toast.error(message);
        }
    };
    useEffect(() => {
        dispatch({ type: 'LOGOUT' });
        dispatch({ type: 'RESET_AUTH'});
        dispatch({ type: 'RESET_FIRM_ONBOARDING_REDUCER'});
        dispatch({ type: 'SET_OTP_PURPOSE', payload: OTP_PURPOSE_ENUM.REGISTER });
      }, []);
    return (
        <>
            <Box sx={{ display:"flex",flexDirection:"column", gap: 2 }}>
                <Typography variant='h1' sx={{ color: '#666666' }}>Register</Typography>
                <Box sx={{ display:"flex",flexDirection:"column", gap: 4  }}>
                    <Box sx={{ display:"flex",flexDirection:"column", gap: {xs: 1, md: 2}  }}>
                        <TextField
                            label = "Mobile Number*"
                            value={mobile}
                            onChange={e=>{
                                const val = e.target.value.replace(/\D/g,"").slice(0,10);
                                setMobile(val);
                                if (val.length === 10 && !/^\d{10}$/.test(val)) {
                                    setErr("Please enter a valid 10-digit mobile number");
                                } else {
                                    setErr("");
                                }
                            }}
                            placeholder="Enter mobile number"
                            error={!!err}
                            helperText={err}
                        />
                        <Box sx={{ display:"flex", alignItems:"center", flexDirection: 'column' }}>
                            <Typography variant='body1' sx={{ color: '#333333',}}>
                                By signing up with HUMBEE, you agree to our
                            </Typography>
                            <Link
                                sx={{ color: '#333', cursor: 'pointer', textDecoration: 'underline', fontWeight: 500 }}
                                onClick={handleTncClick}
                            >
                                Terms & Conditions
                            </Link>
                        </Box>
                    </Box>
                    <Box sx={{ display:"flex", gap: 4 }}>
                    <CustomButton 
                        variant='filled'
                        disabled={!isMobileValid||loading}
                        label={loading ? 'Sending...' : 'Verify Mobile number'}
                        fullWidth
                        onClick={handleSendOtp}
                    />
                    </Box>
                    <Box sx={{ display:"flex", alignItems:"center",justifyContent: 'center', gap: 0.5 }}>
                    <Typography sx={{fontSize:'16px !important', lineHeight: '24px', fontWeight: 600 }}>Already have an account?</Typography>
                    <Link
                        style={{ color: '#995A00', cursor: 'pointer', textDecoration: 'none',  fontWeight: 600, fontSize:'16px', lineHeight: '24px',}}
                        component="button"
                        onClick={() => {
                            navigate('/login');
                        }}
                    >
                        Login
                    </Link>
                    </Box>
                </Box>
            </Box>
            <GlassModal
                open={tncOpen}
                onClose={handleTncClose}
                title="Terms & Conditions"
                scrollable={true}
                maxWidth="600px"
                zIndex={2}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {tncData.tnc.map((item, idx) => (
                    <Box key={idx}>
                    <Typography variant="bodyL" sx={{ borderBottom: '1px solid #D9D9D9', pb: 0.5, marginBottom: 0.5 }}>
                        {item.header}
                    </Typography>
                    <Typography variant="p3">
                        {item.description}
                    </Typography>
                    </Box>
                ))}
                </Box>
            </GlassModal>
        </>
  );
}

export default RegisterForm;